import { DefaultTheme } from 'styled-components';

export default {
  title: 'physics',

  colors: {
    background: '#EFF1F7',
    background_hover: '#FDEFFD',
    black: '#000000',
    primary: '#E15D7E',
    secondary: '#339792',
    grey: '#DDDDDD',
    dark_grey: '#929292',
    white: '#FFFFFF',
    white_variant: '#FAFAFA',
  },
} as DefaultTheme;
